import { render, staticRenderFns } from "./inactiveText-editor.vue?vue&type=template&id=0905e150&scoped=true&"
import script from "./inactiveText-editor.vue?vue&type=script&lang=js&"
export * from "./inactiveText-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0905e150",
  null
  
)

export default component.exports